<template>
  <popup
    :round="round"
    :maskStyle="maskStyle"
    :duration="duration"
    :lockScroll="lockScroll"
    :closeOnClickMask="closeOnClickMask"
    v-model="status"
    :lazyRender="lazyRender"
    @opened="onOpened"
    @closed="onClosed"
  >
    <div class="ps-w">
      <x-wrapper class="ps-ctn">
        <header class="ps-title pf-simbold" v-if="title">{{ title }}</header>

        <slot></slot>
      </x-wrapper>
    </div>

    <x-wrapper class="ps-btm">
      <button @click="close" class="pf-medium">
        <span>{{ closeText }}</span>
      </button>
    </x-wrapper>
  </popup>
</template>
<script>
import popup from '@/components/action-sheet/popup'
import XWrapper from '@/components/x-wrapper'
import props from '../lib/props'
import mixin from '../mixins'
import watchStatus from '@/components/action-sheet/mixins/watchStatus'
export default {
  props: {
    ...props,
    title: String,
    closeText: {
      type: String,
      default: '关闭'
    }
  },
  mixins: [mixin, watchStatus],
  // data() {
  //   return {
  //     status: this.value,
  //   }
  // },
  methods: {
    close() {
      this.$emit('input', false)
    }
  },
  // watch: {
  //   value(n, o) {
  //     this.status = n
  //   },
  //   status(n, o) {
  //     this.$emit('input', n)
  //   },
  // },
  components: {
    popup,
    XWrapper
  }
}
</script>
<style lang="scss" scoped>
$colorPrimary: #ff5900;
.ps-w {
  position: relative;
  max-height: 92vh;
  padding: 0 0.24rem 1.4rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.ps-title {
  font-size: 0.34rem;
  color: #000;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.42rem;
  padding-top: 0.36rem;
  padding-bottom: 0.36rem;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #fff;
}
.ps-btm {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  padding-left: 0.24rem;
  padding-right: 0.24rem;
  background-color: #fff;
  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.8rem;
    background-image: linear-gradient(90deg, #ff8800 0%, $colorPrimary 100%);
    border-radius: 0.4rem;
    font-size: 0.3rem;
    color: #ffffff;
    text-align: center;
  }
  z-index: 99;
}
</style>
